// directives/v-percent.ts
import type { Directive } from "vue"

function formatNumber(number: number) {
  return Number(number || 0).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  })
}

export const vPercent: Directive<HTMLElement, number> = {
  mounted(el, binding) {
    el.textContent = `${formatNumber(binding.value)}%`
  },

  updated(el, binding) {
    el.textContent = `${formatNumber(binding.value)}%`
  },
}
